












































































































































































































import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { CommerceSalesOrder } from '@/models/api/commerce-sales-order'
import { ApiCoupon } from '@/models/api/coupon'
import { SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { PaymentList } from '@/models/api/payment/payment'
import { RawTag } from '@/models/api/tags'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CartItemList } from '@/models/cart/cart-item'
import { CartScopeEq } from '@/models/cart/group/scope'
import CleanUpUnpublishedNoveltyItemObserver from '@/models/cart/novelty/clean-up-unpublished-novelty-item-observer'
import { EngineCartRepository } from '@/models/cart/repository/impl/cart-item/engine-cart-item-repository'
import RemoveItemFromCartService from '@/models/cart/service/remove-item-from-cart-service'
import * as CurrentTime from '@/models/current-time/functions'
import { DateWithoutHour } from '@/models/date-time/date-without-hour'
import {
  DeliveryConfigSpecification,
  DeliveryConfigState,
  DeliveryMethod,
  emptyDeliveryConfigSpecification,
  getDefaultDeliveryTime,
  OnlySingleDeliveryConfigBuilder,
} from '@/models/delivery'
import { AppliedPoint, DiscountAmount, DiscountPrice } from '@/models/discount-amount/discount-amount'
import { NoveltyCampaign } from '@/models/novelty/novelty'
import { ApplicablePoint } from '@/models/point/applicable-point'
import { ApiApplicablePointRepository, ApplicablePointRepository } from '@/models/point/applicable-point-repository'
import { ConditionToApplyPoint, policy as PolicyOfEnablePointApply } from '@/models/point/condition-to-apply-point'
import { AfterPurchaseProcessStatus } from '@/models/purhase/after-purchase-process-status'
import { AppSettingServiceFeeRepository } from '@/models/service-fee/repository/service-fee-repository'
import { convertToApplyBundleDiscountParamter } from '@/services/api/bundle-discount'
import { DeliveryMethodService } from '@/services/api/delivery/deliveryMethod'
import PaymentService from '@/services/api/payment'
import { PointFeatureIsEnabledService } from '@/services/api/point-feature'
import { NoveltyService } from '@/services/novelty'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import OptionsValidator from '@/services/payment/options-validator'
import { BundleApplied } from '@/usecases/novelty/base-price-to-select-novelty'
import { CampaignConstraint } from '@/usecases/novelty/campaign-constraint'
import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { adCodeStore } from '@/util/adcode/store'
import { allRight } from '@/util/either-list'
import { formatPrice } from '@/util/format'
import { InstanceResolver } from '@/util/instanceResolver'
import { NoveltyEntity } from '@spa/components/organisms/cart/novelty/selection'
import { convertToUseCaseState } from '@spa/components/organisms/cart/novelty/util'
import ContactViewItem from '@spa/components/organisms/contact/ViewItem.vue'
import MailMagazineCheckList from '@spa/components/organisms/mail-magazine/MailMagazineCheckList.vue'
import ApplyPoint from '@spa/components/organisms/order/ApplyPoint.vue'
import ApplyCoupon from '@spa/components/organisms/order/coupon/ApplyCoupon.vue'
import TimeSlotSelect from '@spa/components/organisms/order/delivery/TimeSlotSelect.vue'
import OrderCarat from '@spa/components/organisms/order/OrderCarat.vue'
import PaymentViewItem from '@spa/components/organisms/order/payment/ViewItem.vue'
import TotalPrice from '@spa/components/organisms/order/TotalPrice.vue'
import SecurityCodeForm from '@spa/components/organisms/payment/creditcard/SecurityCodeForm.vue'
import DeliveryConfigList from '@spa/components/pages/order/edit/delivery/DeliveryConfigList.vue'
import {
  MailMagazineSubscriptionInteractor,
} from '@spa/components/pages/order/interactor/mail-magazine/subscription-interactor'
import { ContextDependencies } from '@spa/components/pages/order/model/context/once-order/once-order-context'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import {
  DefaultDeliveryMethodRepository,
  DeliveryMethodRepository,
} from '@spa/components/pages/order/model/delivery/delivery-method-repository'
import { ModalConfig, styleAsWarning } from '@spa/components/pages/order/model/modal/modal-config'
import { ListCouponForOrder } from '@spa/components/pages/order/model/order/list-coupon-for-order'
import {
  AtoneError,
  atoneErrorMessages,
  parseAtoneErrorCodeAndMessage,
} from '@spa/components/pages/order/model/payment/atone-error'
import { setupPaymentInitializationSpec } from '@spa/components/pages/order/model/payment/initialization'
import { PaymentInitializationSpec } from '@spa/components/pages/order/model/payment/initialization/specification'
import { AtoneScriptLoader, PaidyScriptLoader } from '@spa/components/pages/order/model/payment/payment-script-loader'
import { AppliedCouponState, ApplyCouponState, NotApplicableCouponState, NotApplyingCouponState } from '@spa/components/pages/order/order/apply-coupon/apply-coupon-state'
import { selectCheckoutView } from '@spa/components/pages/order/order/checkout/model/select-checkout-view'
import { AtoneProcessingState, CheckoutProcessState, PaidyProcessingState } from '@spa/components/pages/order/order/models/checkout-process-state'
import { CheckoutKey, CheckoutStore, MismatchLengthError } from '@spa/components/pages/order/order/models/checkout-store'
import { sortOrderResultsByOrderList } from '@spa/components/pages/order/order/sort-order-results-by-order-list'
import { guardOnCart, guardOnDelivery, guardOnUser } from '@spa/components/pages/order/routing/guard'
import { toQuery } from '@spa/components/pages/order/scope-transpiler'
import { log } from '@spa/log'
import { PluginMixin } from '@spa/mixins/plugin'
import { OrderHistoryApiService } from '@spa/services/api/orderHistory'
import {
  CouponEstimateParameter,
  PurchaseEstimate,
  PurchaseService, SalesOrder,
} from '@spa/services/api/purchase'
import { CouponError } from '@spa/services/api/purchase/discount'
import {
  atoneAuthenticatedCallbackFactory,
  atoneCancelledCallbackFactory,
  atoneErrorCallbackFactory,
  atoneFailedCallbackFactory,
  atoneSucceededCallbackFactory,
  configAtone,
  convertCartItems as convertCartItemsForAtone,
  makeAtonePayment,
} from '@spa/services/atone'
import {
  Order as OrderItem,
  OrderPurchaseFail,
  OrderPurchaseResult,
  OrderService,
  timeoutErrorExistsInPurchaseResult,
} from '@spa/services/order'
import CompleteDataBuilder from '@spa/services/order/complete-data-builder'
import {
  configPaidy,
  convertCartItems as convertCartItemsForPaidy,
  makePaidyPayload,
  paidyCallbackFactory,
  PaidyResponse,
} from '@spa/services/paidy'
import store from '@spa/store'
import { LoadAppSettingParameter } from '@spa/store/modules/appSetting/actions'
import { LoadWithScopePayload } from '@spa/store/modules/cart/actions'
import { isSinglePurchasable } from '@spa/store/modules/cart/function'
import { CartItem } from '@spa/store/modules/cart/types'
import { Contact } from '@spa/store/modules/contact/types'
import { LoadCouponPayload } from '@spa/store/modules/coupon/actions'
import {
  Delivery,
  DeliveryConfig,
  OrderConfirmState,
  OrderResult,
  Payment,
  typeIsCreditCard,
} from '@spa/store/modules/orderConfirm/types'
import { User } from '@spa/store/modules/user/types'

import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { chain, Either, left, right } from 'fp-ts/lib/Either'
import { fromNullable, none, Option, some } from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'
import _ from 'lodash'
// https://www.npmjs.com/package/vue-bootstrap-datetimepicker#usage-example
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css'
import { VueConstructor } from 'vue'
import DatePicker from 'vue-bootstrap-datetimepicker' // TODO: This package requires 'moment', which has large size
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Location } from 'vue-router'
import { createPurchaseExecutionProcessFunctions, PurchasePreparationState } from './model/purchase-execution/execute-purchase'
import { createPurchaseErrorMessage, hasErrorOnCauseType } from './order/purchase-error/purchase-error-message'
import { convertFromOrderPurchaseResult, createRedirectHtmlRenderer } from './order/redirect-html-renderer'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    ApplyCoupon,
    ApplyPoint,
    DatePicker,
    ContactViewItem,
    MailMagazineCheckList,
    PaymentViewItem,
    TimeSlotSelect,
    OrderCarat,
    SpaErrorDialog,
    TotalPrice,
    SecurityCodeForm,
    DeliveryConfigList,
  },
})
/**
 * @see Order.created
 */
export default class Order extends Mixins<PluginMixin>(PluginMixin) {
  /**
   * scopeクエリが不正などの理由で予期しないscopeが渡される可能性がある。
   * 例えば { kind: ScopeKind(''), value: ScopeValue(undefined) }
   *
   * 詳細は client/spa/src/router/index.ts のコメントを参照
   */
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  behavior: BehaviorConfig

  @Prop({ required: true })
  purchaseService: PurchaseService

  @Prop({ required: true })
  orderService: OrderService

  @Prop({ required: true })
  noveltyService: NoveltyService

  @Prop({ required: true })
  listCoupon: ListCouponForOrder

  @Prop({ default: () => ApiApplicablePointRepository.create() })
  pointRepository: ApplicablePointRepository

  @Prop({ required: true })
  contextFactory: (deps: ContextDependencies) => OrderContext

  get context(): OrderContext {
    return this.contextFactory({ novelty: this.noveltyCampaign })
  }

  @Prop({ default: () => PointFeatureIsEnabledService.create() })
  pointIsEnabledService: PointFeatureIsEnabledService

  /**
   * TODO: appSetting取得をstoreから取り除いたら削除
   * brandを算出する代わりに、appSettingServiceをDIする
   * @deprecated
   * @see https://github.com/my-color/front/pull/2027
   */
  get brandEnglishName(): string | null {
    return this.scope.kind.isBrand ? this.scope.value.toString() : null
  }

  initializationStatus: Status = Status.Pending
  orderStatus: Status = Status.Pending

  estimateStatus: Status = Status.Pending
  get estimateIsLoading(): boolean {
    // estimate の結果によってポイント適用上限が変化するが、
    // 現在適用しているポイントが新しいポイント適用上限に違反している場合、
    // それによってさらに estimate が再更新される場合がある.
    // そのため、ポイント適用上限の再取得も完了して初めて
    // 「estimateのローディングが終わった」と見なす.
    // @see https://github.com/my-color/front/issues/5400
    return this.estimateStatus === Status.Loading ||
      this.loadingApplicablePoint
  }

  showModal: boolean = false

  modalMessage: string = ''

  /**
   * showModal, modalMessageなどはOrder.vueグローバルに散在している、旧モーダルの表示設定。
   * 上記に対して、modalConfigは新モーダル用の表示設定で、表示・非表示と、表示する場合に必要な情報を1カ所にまとめたもの。
   * 旧モーダルは徐々にStranglerパターンにて消滅させるか、Order.vue全体のリファクタと共にあるべき実装を検討すること。
   */
  modalConfig: ModalConfig = {
    show: false,
  }

  purchaseMenu: any = null

  purchaseEstimates: PurchaseEstimate[] = []

  deliveryDate: DateWithoutHour | null = null

  /**
   * 配送時間帯の初期値を設定
   *
   * この値はエンジンまたは配送業者に依存するため、MCフロント側で持つべき知識ではない。
   * しかし、現状（2021.03.08）ではMCフロント側で持たざるを得ない。
   * 配送時間帯を指定しないあるいは指定不可の時は、この初期値を設定して注文しなければならない。
   * 詳細はこちら: https://github.com/my-color/front/pull/4959#pullrequestreview-606007153
   */
  deliveryTimeSlot: string = getDefaultDeliveryTime().id
  selectedTimeSlotLabel: string = getDefaultDeliveryTime().label

  securityCode: string = ''

  shouldRedirect: boolean = false

  currentTime = CurrentTime.create()

  datepickerOption = {
    locale: 'ja',
    format: 'YYYY/M/DD',
    useCurrent: 'day',
    minDate: this.currentTime.now,
    maxDate: this.currentTime.now,
    dayViewHeaderFormat: 'YYYY年 MM月',
  }

  provisionalOrderIdForSingleOrder: string | null = null

  paymentService = new PaymentService()
  availablePaymentList: PaymentList = PaymentList.empty()

  atoneScriptLoader: AtoneScriptLoader = new AtoneScriptLoader()
  atoneCheckoutProcessState: CheckoutProcessState<AtoneProcessingState> = CheckoutProcessState.forAtone()

  paidyScriptLoader: PaidyScriptLoader = new PaidyScriptLoader()
  paidyHandler: PaidyHandler
  paidyCheckoutProcessState: CheckoutProcessState<PaidyProcessingState> = CheckoutProcessState.forPaidy()

  errorMessage: string = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
  errorMessageMultiOrderDisallowed: string = `
    複数注文の場合、このお支払い方法はご利用いただけません。<br/>
    別のお支払い方法を選択してください。
  `

  readonly orderHistoryApiService = new OrderHistoryApiService()

  noveltyCampaign: NoveltyCampaign | null = null
  noveltyStates: NoveltyEntity[] = []

  deliveryConfigSpec: DeliveryConfigSpecification = emptyDeliveryConfigSpecification

  pointIsEnabled = false

  serviceFeePercent: number | null = null

  mailMagazineSubscriptionInteractor: MailMagazineSubscriptionInteractor =
    MailMagazineSubscriptionInteractor.initWithDefaultRepository()

  atoneErrors: AtoneError[] = []

  get cardPaymentProviderConfig() {
    return getCreditcardPaymentProvierServiceConfig()
  }
  get cardPaymentProvider() {
    return this.cardPaymentProviderConfig.forPurchase
  }
  get deliveryPlan() {
    // FIXME
    return _.get(this.purchaseEstimates[0], 'deliveryPlan')
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  applicablePoint: ApplicablePoint = ApplicablePoint.empty
  loadingApplicablePoint = false
  pointInitTriggered: boolean = false
  get appliedPoint(): number {
    return this.$store.state.orderConfirm.point.applied
  }
  get discountedByPoint(): number {
    return this.$store.state.orderConfirm.point.discounted
  }
  onPointApply(applied: number) {
    this.pointInitTriggered = false
    this.$store.dispatch('orderConfirm/applyPoint', {
      applied,
      // 1stリリースでは、1pt = 1円の決め打ち
      // https://my-color.esa.io/posts/559#%E5%89%B2%E5%BC%95%E9%A1%8D
      discounted: applied,
    })
  }
  /**
   * - エラーが発生した際にerror callbackが実行される
   *   - エラーの情報が引数として渡される
   *   - Frontはデフォルトの文言+エラーの情報に応じた文言でエラーモーダルを表示する
   * - atoneのモーダルを閉じる際にfailed callbackが実行されるケースがある
   *   - 引数なし
   *   - Frontはデフォルトの文言でエラーモーダルを表示する
   * したがって、failed callbackによって文言の上書きがされないように、
   * エラーの情報をVueコンポーネント内で保持することを選択した。
   *
   * @see https://github.com/my-color/growthpalette-pm/issues/195#issuecomment-1746058331
   */
  storeAtoneErrorCodeAndMessage(errors: any[]) {
    this.atoneErrors = parseAtoneErrorCodeAndMessage(errors)
  }
  clearAtoneErrorCodeAndMessage() {
    this.atoneErrors = []
  }
  get conditionToApplyPoint(): ConditionToApplyPoint {
    return PolicyOfEnablePointApply.default({
      orders: this.orderList,
    })
  }

  get estimatedPoint(): number {
    return this.purchaseEstimates.reduce(
      (total: number, e) => total + e.point.amount,
      0
    )
  }

  initPointFeatureIsEnabled(): Promise<void> {
    return this.pointIsEnabledService.isEnabled().then((response) => {
      this.pointIsEnabled = response.on
    })
  }

  @Watch('purchaseEstimates')
  initApplicablePoint(): Promise<Either<Error, void>> {
    this.loadingApplicablePoint = true

    return this.pointRepository.get({
      item_price: Math.max(this.subtotalPrice - this.estimatedDiscountPrice, 0),
      commission: this.commission,
      delivery_fee: this.shipping,
    }).then(
      result => result.map<void>(applicable =>
        this.applicablePoint = applicable
      )
    ).finally(() => {
      this.loadingApplicablePoint = false
    })
  }

  initAppliedPoint() {
    this.$store.dispatch('orderConfirm/initAppliedPoint')
    this.pointInitTriggered = true
  }

  onPointInput() {
    this.pointInitTriggered = false
  }

  isPurchasableCartItem(item: CartItem): boolean {
    return isSinglePurchasable(item)
  }

  get displayCartItems(): CartItem[] {
    return this.$store.getters['cart/displayItemsWithFilter'](this.isPurchasableCartItem)
  }

  get cartItems(): CartItem[] {
    const carts = this.$store.getters['cart/itemsWithFilter'](this.isPurchasableCartItem)

    return this.context.filter.cartItems(carts)
  }

  /**
   * Novelty items can be ordered only when they are available under the current campaign.
   * TODO: Kick out to domain logic
   */
  get noveltyCartItems(): CartItem[] {
    if (!this.noveltyCampaign) {
      return []
    }

    const noveltyCarts = this.$store.getters['cart/noveltyItemsWithFilter'](
      this.isPurchasableCartItem
    )

    const noveltySkuIds = this.noveltyCampaign.noveltyList.map(n => n.skuId)

    return noveltyCarts.filter(cart => _.includes(noveltySkuIds, cart.skuId))
  }

  get noveltyCount(): number {
    if (this.noveltyCartItems.length === 0) {
      return 0
    }

    return this.noveltyCartItems.reduce((sum, item) => sum + item.unitCount, 0)
  }

  get isPreOrderContained(): boolean {
    return this.orderList.some(order => order.kind === 'preorder')
  }

  get orderList(): OrderItem[] {
    return this.orderService.createOrderFromCartItems(this.cartItems, this.deliveryDateForStandardOrder)
  }

  get checkoutStore(): CheckoutStore {
    return CheckoutStore.create(
      this.orderList,
      this.purchaseEstimates,
      this.discountedByPoint
    ).mapLeft(
      (error) => {
        // orderListとpurchaseEstimatesの数が合っていない場合は無害な初期値としてemptyを利用する
        if (error instanceof MismatchLengthError) {
          return CheckoutStore.empty()
        }

        log.error('error on creating checkout store: ', error)
        this.modalMessage = `${this.errorMessage}<br/>カート画面に戻ります。`
        this.showModal = true
        this.shouldRedirect = true

        return CheckoutStore.empty()
      }
    ).value
  }

  get canScheduleDelivery(): boolean {
    return this.$store.getters['appSetting/scheduledDelivery']
  }

  get deliveryDateForStandardOrder(): string {
    return this.deliveryDate === null ? '未指定' : this.deliveryDate.formattedDate('YYYY年MM月DD日')
  }

  get cartIds(): string[] {
    return _.map(this.cartItems, item => item.id)
  }

  get cartPath(): string {
    if (InstanceResolver.isSingle()) {
      return '/cart'
    }

    // this.scopeが不完全な場合はカート一覧を返す
    if (!this.scope.kind.toString() || !this.scope.value.toString()) {
      return '/carts'
    }

    return `/${this.scope.kind.toString()}/${this.scope.value.toString()}/cart`
  }

  get orderHistoryPath(): string {
    return '/mypage/order'
  }

  get orderConfirm(): OrderConfirmState {
    return this.$store.state.orderConfirm
  }

  get delivery(): Delivery | null {
    return this.orderConfirm.delivery
  }

  get deliveryContact(): Contact | null {
    if (!this.delivery) {
      return null
    }

    const { id } = this.delivery

    return this.$store.getters['contact/get'](id)
  }

  get errorOnContactLoad() {
    return _.get(this.$store.state.contact.error, 'load')
  }

  get payment(): Payment | null {
    return this.orderConfirm.payment
  }

  get paymentType(): PaymentType | undefined {
    return _.get<Payment, 'payment_type'>(this.payment, 'payment_type')
  }

  get checkoutComponent(): VueConstructor {
    return selectCheckoutView(this.checkoutStore, this.payment)
  }

  get errorOnPurchaseLoad() {
    return _.get(this.$store.state.purchase.error, 'load')
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get errorOnAppSettingLoad() {
    return _.get(this.$store.state.appSetting, 'error.load')
  }

  get isFirstShareItem() {
    return this.$store.getters['user/getFirstShareItem']
  }

  get displayTotalItemCount(): number {
    return _.sumBy(this.displayCartItems, item => _.toNumber(item.unitCount))
  }

  get isFreeShipping(): boolean {
    return this.$store.getters['cart/isFreeShippingOnCatalogOnlyWithFilter'](this.isPurchasableCartItem)
  }

  get subtotalPrice(): number {
    return this.checkoutStore.subtotalPrice
  }

  get subtotalPriceList(): number[] {
    return this.checkoutStore.subtotalPriceList
  }

  get commission(): number {
    return this.checkoutStore.commission
  }

  get commissionList(): number[] {
    return this.checkoutStore.commissionList
  }

  get serviceFees(): number[] {
    return this.checkoutStore.serviceFeeList
  }

  get shipping(): number {
    return this.isFreeShipping ? 0 : this.checkoutStore.shipping
  }

  get shippingList(): number[] {
    return this.checkoutStore.shippingList
  }

  get totalPrice(): number {
    return this.checkoutStore.totalPrice
  }

  get discountAmount(): DiscountAmount {
    return new DiscountAmount(
      DiscountPrice.valueOf(this.discountPrice),
      AppliedPoint.valueOf(this.discountedByPoint)
    )
  }

  get discountPrice(): number {
    return Math.min(this.estimatedDiscountPrice, this.subtotalPrice)
  }

  /**
   * Use estimated response value.
   * This MAY not be the same as a real discount, because discount is applied to each order's subtotal price.
   */
  get estimatedDiscountPrice(): number {
    return this.checkoutStore.totalDiscountPrice
  }

  // Use estimated response value.
  // This MAY not be the same as a real discount, because discount is applied to each order's subtotal price.
  get bundleDiscountPrice(): number {
    return this.checkoutStore.bundleDiscountPrice
  }

  /**
   * クーポン割引額.
   * クーポンが適用されていない場合は割引額はnoneとする。
   */
  get couponDiscountPrice(): Option<number> {
    return this.applyCouponState.coupon.fold(
      none,
      () => some(this.applyCouponState.discount)
    )
  }
  get applyCouponState(): ApplyCouponState {
    /**
     * {@see estimateIsLoading}を使うと、ポイント適用上限の取得完了までの間「クーポン割引額無し」という扱いになる.
     * しかし実際には estimate api が少なくとも一回終わった時点でクーポン割引額は一旦確定しているのだから、
     * ポイント適用上限の取得完了まで待つ必要は無い.
     * むしろポイント適用上限の取得まで待ってしまうと、初期化処理（{@see initPurchaseEstimate}）でクーポン割引額が取得し終わった後でも
     * CouponDiscountPrice = none になってしまい、「割引が発生していなければクーポン選択解除」の処理が発火しない.
     *
     * なので、{@see estimateIsLoading}は参照せず{@see estimateStatus}を直接チェックしている.
     */
    if (this.estimateStatus === Status.Loading) {
      return new NotApplyingCouponState()
    }

    if (this.selectedCoupon === null) {
      return new NotApplyingCouponState()
    }

    const aggregatedDiscountAndErrors = this.purchaseEstimates.reduce<{ discount: number, errors: CouponError[] }>(
      (xs, estimate) => fromNullable(estimate.price.discount).fold(
        xs,
        d => ({
          discount: xs.discount + d.coupon.amount,
          errors: [...xs.errors, ...d.coupon.errors],
        })
      ),
      { discount: 0, errors: [] }
    )

    /**
     * errorsが存在する場合、クーポン適用不可と見なす
     * @see https://github.com/my-color/growthpalette-front/pull/7642#discussion_r1361676347
     */
    const [firstError, ...restErrors] = aggregatedDiscountAndErrors.errors
    if (firstError) {
      log.warn(`Selected coupon is not applicable.`)

      return new NotApplicableCouponState([firstError, ...restErrors])
    }

    /**
     * 2023年10月現在、割引額が0円であっても見積りAPIはクーポン適用可と見なすため、
     * client側でガードを行っている。
     *
     * TODO:
     * - 割引額が0円の場合は適用不可となるようにserver側のクーポン適用のドメインモデルを修正する
     * - 上記が完了次第この条件分岐は不要となるので削除する
     */
    if (aggregatedDiscountAndErrors.discount === 0) {
      log.warn(`Selected coupon does not offer any discount.`)

      return new NotApplicableCouponState([{
        id: 'must-exist-discount-amount',
        label: 'クーポンによって1円以上の割引が適用されません',
      }])
    }

    return new AppliedCouponState(
      /**
       * クーポンコードは一覧取得せず、クーポンコードでAPIに問い合わせてはじめてクーポンの存在を確認できるように実装されている。
       * したがって適用するクーポンのオブジェクトは this.selectedCoupon しか知り得ない状態となっている。
       *
       * TODO:
       * applyCouponStateはclient側の状態に依存せず、見積りAPIの結果のみから算出されるものにしたい
       *   - ApplyCouponStateとしてApiCoupon全体を保持する必要があるか精査する
       *   - 必要な情報が少ない場合、見積りAPIのレスポンスに含めても良いかもしれない
       *   - 必要な情報が多い場合、見積りAPIがクーポンIDを返却し、ApiCouponをここで取得しても良いかもしれない
       *
       * @see https://github.com/my-color/growthpalette-front/pull/7642
       */
      this.selectedCoupon,
      aggregatedDiscountAndErrors.discount
    )
  }

  /**
   * 見積もりAPIに送信すべきクーポン割引の内容。
   * @see CouponEstimateParameter
   */
  get couponEstimateParrameter(): CouponEstimateParameter | undefined {
    if (!this.selectedCoupon) {
      return
    }

    return {
      id: this.selectedCoupon.id,
    }
  }

  get tax(): number {
    return _.sum(_.map(this.purchaseEstimates, 'price.tax'))
  }

  get rewardCarat(): number {
    const taxOfSubtotal = _.sum(_.map(this.purchaseEstimates, 'price.order.priceIncludingTax.tax'))
    const subtotalWithoutTax = Math.ceil(this.subtotalPrice - taxOfSubtotal)

    const caratRate = 0.01

    return Math.floor(subtotalWithoutTax * caratRate)
  }

  get currentCarat(): number {

    return this.user.current_point || 0
  }

  get expectedCarat(): number {
    return this.currentCarat + this.rewardCarat
  }

  get coupons(): ApiCoupon[] {
    return this.$store.getters['coupon/availableCouponsWithoutCouponCode']
  }

  get couponCodeInputted(): string {
    return this.$store.getters['coupon/couponCodeInputted']
  }

  /**
   * ユーザにより適用の意志が表明されているクーポンを取得する。
   * - クーポンの入力方式（選択式・コード式）は関知しない。
   */
  get selectedCoupon(): ApiCoupon | null {
    return this.$store.state.orderConfirm.coupon.selected
  }

  /**
   * estimateを通過し、注文時に適用されてよいことがわかったクーポン。
   * クーポンの入力方式（選択式・コード式）は関知しない。
   */
  get appliedCoupon(): ApiCoupon | null {
    return this.applyCouponState.coupon.toNullable()
  }

  get isReplacedForSale(): boolean {
    return this.$store.state.cart.isReplacedForSale
  }

  get orderButtonIsEnabled(): boolean {
    const paymentType = _.get<Payment, 'payment_type'>(this.payment, 'payment_type')

    if (paymentType === 'atone' && !this.atoneScriptLoader.loaded) {
      return false
    }

    if (paymentType === 'paidy' && !this.paidyScriptLoader.loaded) {
      return false
    }

    /**
     * FIXME: estimateStatus と initializationStatus を1つのフラグで管理する
     * すでに注文を行っているかを orderStatus が、
     * 注文の準備が終わっているかを estimateStatus と initializationStatus が管理する。
     * 後者を2種類のstatusに分けている理由としては、状態変化のトリガーが異なるため。
     *
     * initializationStatus がページ初期化時のみに変化する状態なのに対して
     * estimateStatus は配送方法などをwatchし、それらの変化に応じて状態も変化する。
     * ページの初期化と見積もりが同タイミングで起きた場合に
     * 想定外の状態変化が起きてしまう可能性があるため2つに分けているが、本来は統合するのが望ましい。
     *
     * @see https://github.com/Everforth/growthpalette-front/pull/7964#discussion_r1586130463
     */
    return this.estimateStatus === Status.Completed &&
      this.initializationStatus === Status.Pending &&
      this.orderStatus === Status.Pending
  }

  get noveltySummary(): CampaignSummary | null {
    if (!this.noveltyCampaign) {
      return null
    }

    return new CampaignSummary(
      this.noveltyCampaign,
      convertToUseCaseState(this.noveltyStates),
      // this.cartItems は現在のスコープのカート内の単発注文商品全てから、
      // 現在公開されていないノベルティを除外した商品全て。
      // これも親子商品などは揃っており現在のスコープのカート内の単発注文商品全てとみなせるため、
      // wholeCartItemList として扱う。
      new CartItemList(this.cartItems),
      this.bundleApplied
    )
  }
  get bundleApplied(): BundleApplied {
    return { discount: this.bundleDiscountPrice }
  }

  get noveltyConstraint(): CampaignConstraint | null {
    if (!this.noveltySummary) {
      return null
    }

    return new CampaignConstraint(this.noveltySummary)
  }

  get mailMagazineList(): RawTag[]  {
    return this.mailMagazineSubscriptionInteractor.subscriptionList
  }

  handleNoveltyStatesChange(states: NoveltyEntity[]): void {
    this.noveltyStates = states
  }

  handleResetNoveltySelection(val: Error): void {
    log.error(val)

    this.showResetNoveltySelection()
  }

  showResetNoveltySelection(): void {
    this.shouldRedirect = true
    this.modalMessage = 'ノベルティを選択いただける範囲を越えているため、選択を解除しました。再度ご確認の上選択してください。'
    this.showModal = true
  }

  get showSecurityCode(): boolean {
    return this.paymentType !== undefined
      && typeIsCreditCard(this.paymentType)
      && this.cardPaymentProviderConfig.viewConfig.paymentForm.requireSecurityCode
  }

  setReplacedForSale(flag: boolean) {
    this.$store.commit('cart/isReplacedForSale', flag)
  }

  formatPrice(price: number): string {
    return formatPrice(price)
  }

  disableDeliverySchedule() {
    log.warn('disabling delivery schedule')
  }

  get deliveryConfigList(): DeliveryConfigState[] {
    return this.deliveryConfigSpec.configList
  }

  /**
   * TODO: もし配送設定が複数ある場合は、配送設定ごとにセットされなければならない値だから、
   * DeliveryConfigList.vue か SetDeliveryConfig.vue で処理されるべきかもしれない。
   * しかしその場合、ストアやプロパティでの値も配送設定ごとに保持されなければならない。
   *
   * 現状の仕様としてはここで問題ない。
   */
  onChangeDeliveryConfig(
    dc: DeliveryConfigState,
    /**
     * ユーザーによる能動的な変更である場合には、trueを指定する
     */
    isChangeTriggeredByUser: boolean = true
  ) {
    this.deliveryConfigSpec = this.deliveryConfigSpec.replace(dc)

    this.$store.dispatch('orderConfirm/setDeliveryMethod', {
      method: dc.selectedDeliveryMethod,
    })

    this.setDeliveryDateTime(dc)
    if (dc.selectedOkihaiPlace) {
      this.$store.dispatch('orderConfirm/setOkihaiPlace', dc.selectedOkihaiPlace)
    }

    if (isChangeTriggeredByUser) {
      this.$store.dispatch('orderConfirm/setSelectedDeliveryConfig', {
        deliveryMethodDetail: dc.selectedDeliveryMethod,
        deliveryDate: dc.selectedDeliveryDate,
        deliveryTime: dc.selectedDeliveryTime,
        okihaiPlace: dc.selectedOkihaiPlace,
      })
    }
  }

  /**
   * NOTE: 既存実装に従ってプロパティとストア両方に値をセットする
   * おそらくストアは、画面遷移を超えて値を保持するために使われており、
   * 購入の際はプロパティの値を使っている
   */
  setDeliveryDateTime(dc: DeliveryConfigState) {
    this.deliveryDate = dc.selectedDeliveryDate
    this.deliveryTimeSlot = dc.selectedDeliveryTime.id
    this.selectedTimeSlotLabel = dc.selectedDeliveryTime.label

    this.$store.dispatch('orderConfirm/setDeliveryDate', {
      deliveryPlanDate: dc.selectedDeliveryDate,
      deliveryTimeSlot: dc.selectedDeliveryTime.id,
    })
  }

  async onChangeDeliveryMethod(config: DeliveryConfigState, dm: DeliveryMethod) {
    try {
      const deliveryMethodDetail = await this.deliveryMethodRepository.get(
        dm.id,
        {
          cartIds: config.context.cartIds.join(','),
          deliveryId: config.context.deliveryId,
          payment: config.context.payment,
          deliveryMethod: dm.externalId,
        }
      )

      this.onChangeDeliveryConfig(config.changeDeliveryMethod(deliveryMethodDetail))
    } catch (e) {
      log.error('error on changing delivery method', e)

      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }
  }

  /**
   * Member fields payment, delivery and cartIds MUST be loaded in advance
   */
  async initPurchaseEstimate() {
    /**
     * ポイントの適用はクーポンよりも後なので、ポイント適用上限はクーポン適用結果に応じて変化する.
     * そのため、まずはポイントを無視した状態で見積もりを取得して適用上限を確認してから、
     * 改めてポイントを含めた見積もりを再取得している.
     *
     * @see updatePurchaseEstimate
     * @see https://my-color.esa.io/posts/600
     * @note
     * 見積もりを取得した時、ポイントが適用上限を超えていたら無効にしつつその旨をレスポンスに乗せて返す、
     * というような仕組みになれば、client側は単に一発estimateを叩いて、あとはその結果でフィールドを埋めるのみ、
     * というかたちに出来るかもしれない.
     * （{@see https://github.com/my-color/front/pull/7009} ではスコープ外として一旦スルー）
     */
    await this.loadPurchaseEstimate({
      bundle: true,
      coupon: true,
      point: false,
    })

    await this.couponDiscountPrice.map(async (price) => {
      if (this.appliedCoupon && price === 0) {
        /*
         * @see https://github.com/my-color/front/pull/6390
         */
        await Promise.all([
          this.$store.dispatch('orderConfirm/initCoupon'),
          this.$store.dispatch('orderConfirm/initAppliedPoint'),
        ])
        log.info('selected coupon not offer any discount, so coupon-selection was initialized')
      }
    }).getOrElse(Promise.resolve())

    if (this.appliedPoint > 0) {
      await this.initApplicablePoint()
      if (this.appliedPoint > this.applicablePoint.toNumber()) {
        await this.$store.dispatch('orderConfirm/initAppliedPoint')
      }
      await this.loadPurchaseEstimate()
    }
  }

  /**
   * 注文方法の変更ごとに支払金額の見積もりを再取得する.
   *
   * watch の依存関係について、esaに俯瞰した図を記載している.
   *
   * @see https://github.com/my-color/front/pull/2104#issuecomment-521156229
   * @see https://my-color.esa.io/posts/600#%E4%BE%9D%E5%AD%98%E9%96%A2%E4%BF%82
   */
  @Watch('delivery')
  @Watch('selectedCouponId')
  @Watch('appliedPoint')
  async updatePurchaseEstimate() {
    if (_.isEmpty(this.purchaseEstimates)) {
      return  // Skip until estimate is initiated.
    }

    await this.loadPurchaseEstimate()
  }

  async loadPurchaseEstimate(
    enableDiscountParamForEstimate: EnableDiscountParamForEstimate = allDiscountsEnabledForEstimate
  ) {
    // TODO: Refactoring
    if (!this.payment || !this.delivery || _.isEmpty(this.cartIds)) {
      return
    }

    const getEstimate = (order: OrderItem) => {
      const cartIds = _.map(order.cartItems, 'id')

      return this.purchaseService.getEstimate(
        // 'estimate' parameter
        {
          cartIds: (cartIds || []).join(','),
          payment: {
            ...this.payment!,
            point: {
              kind: 'point',
              amount: enableDiscountParamForEstimate.point ? this.appliedPoint : 0,
            },
          },
          deliveryId: _.get(this.delivery!, 'id'),
          deliveryMethod: _.get(this.delivery!, 'deliveryMethod'),
          unattendedDelivery: (
            this.orderConfirm.delivery
            && this.orderConfirm.delivery.unattendedDelivery
          ) ? this.orderConfirm.delivery.unattendedDelivery : null,
          ...enableDiscountParamForEstimate.coupon &&
            order.kind === 'standard' &&
            {
              discount: {
                coupon: this.couponEstimateParrameter,
              },
            },
        },
        convertToApplyBundleDiscountParamter(enableDiscountParamForEstimate.bundle ? order.cartItems : [])
      )
    }

    /* Start calling */
    this.estimateStatus = Status.Loading

    /**
     * Call API
     * orderListの並び順とpurchaseEstimatesの並び順を一致させる必要がある
     */
    const purchaseEstimates = await Promise.all(this.orderList.map(getEstimate))

    if (!allRight(purchaseEstimates)) {
      log.error('error on loading purchase estimate', purchaseEstimates.map(r => r.value))

      this.estimateStatus = Status.Failed

      // TODO: Should it always redirect to the cart page?
      this.modalMessage = `${this.errorMessage}<br/>カート画面に戻ります。`
      this.showModal = true
      // TODO: use callback on closeModal
      this.shouldRedirect = true

      return
    }

    this.purchaseEstimates = purchaseEstimates.map(p => p.value)

    // TODO maybe separate delivery date by order
    // Promsie#allは呼び出し維持の順番を保持するので、0番目＝通常の注文に対するestimate
    const date = this.purchaseEstimates[0].deliveryPlan.date
    const { year, month, day } = date

    const beginOfDeliverable = 1
    const endOfDeliverable = 7

    this.datepickerOption.minDate = new Date(year, month - 1, day + beginOfDeliverable)
    this.datepickerOption.maxDate = new Date(year, month - 1, day + endOfDeliverable)

    this.estimateStatus = Status.Completed
  }

  get purchaseParamsBase() {
    const delivery = this.delivery!
    const deliveryDate = this.deliveryDate
    const deliveryTimeSlot = this.deliveryTimeSlot
    const maybeAdCode = adCodeStore.read()
    const couponId = this.appliedCouponId
    const discount = this.couponDiscountPrice.getOrElse(0)
    const referral = this.user.referral || null

    return {
      delivery,
      deliveryDate,
      deliveryTimeSlot,
      ...fromNullable(this.orderConfirm.delivery)
        .chain(d => fromNullable(d.unattendedDelivery))
        .fold<{ unattendedDelivery: string | null }>(
          { unattendedDelivery: null },
          unattendedDelivery => ({ unattendedDelivery })
        ),
      ...maybeAdCode.map<{ adCode?: string }>(adCode => ({ adCode })).getOrElse({}),
      ...couponId && { couponId },
      // Discount value validation is not interested here, and validated on the server-side.
      ...discount && { discount },
      cartScope: this.scope,
      referral,
    }
  }

  get deliveryMethodRepository(): DeliveryMethodRepository {
    return new DefaultDeliveryMethodRepository(
      DeliveryMethodService.create(),
      this.scope
    )
  }

  async created() {
    this.initializationStatus = Status.Loading
    // Avoid spinner to be stopped because other page's LoadingMixin can call 'view/stopLoading'
    await store.dispatch('view/startLoading')

    try {
      await this.init()

      this.initializationStatus = Status.Pending
    } catch (error) {
      log.error(error)

      this.initializationStatus = Status.Failed
    } finally {
      // Stop ViewState loading, which is started from beforeRouteEnter
      await store.dispatch('view/stopLoading')
    }

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  // TODO: test
  async initNoveltyCampaign(): Promise<void> {
    const cleanUpObserver = CleanUpUnpublishedNoveltyItemObserver.create(
      {
        items: new CartItemList(this.cartItems),
      },
      this.noveltyService,
      RemoveItemFromCartService.create(
        new EngineCartRepository()
      )
    )

    const promiseCleanUp = new Promise<void>((resolve, reject) => {
      let promise = Promise.resolve()
      cleanUpObserver
        .onFinishCleanUp(async () =>
          promise = this.$store.dispatch('cart/loadWithScope', {
            force: true,
            scope: this.scope,
          })
        )
        .onErrorInCleanUp((result) => {
          log.error({ result })
          reject(new Error('error occured in clean up'))
        })
        .onFinish(() => promise.then(resolve))
    })
    const campaignResult = await this.noveltyService.getFirst()

    if (campaignResult.isLeft()) {
      // TODO: Error handling

      return promiseCleanUp.then(() => log.debug('initNoveltyCampaign'))
    }

    this.noveltyCampaign = campaignResult.value

    return promiseCleanUp.then(() => log.debug('initNoveltyCampaign'))
  }

  async initAppSetting(): Promise<void> {
    const param: LoadAppSettingParameter = {
      brand: this.brandEnglishName,
    }
    await this.$store.dispatch('appSetting/load', param)

    if (this.errorOnAppSettingLoad) {
      this.disableDeliverySchedule()
    }
  }

  async initServiceFee(): Promise<void> {
    /**
     * 本来であれば具象クラスへの依存は避けるべきだが、下記の理由からここで直接newしている。
     * - appsettingsから取得していることが暫定的な対応である
     *   - https://github.com/my-color/front/issues/6175 のv2段階
     * - すでにOrder.vueはフィールドが多く、複雑
     * - Vueコンポーネントの自動テストが実行できているわけではない
     * サービス手数料を表示するための依存関係が整理された段階でもなお
     * Order.vueがなんらかのServiceFeeRepositoryの具象クラスに依存している場合は、
     * propsで具象クラスを注入することを検討すること。
     * @see https://github.com/my-color/front/pull/6384#discussion_r866488571
     */
    const result = await new AppSettingServiceFeeRepository().get()

    /**
     * サービス手数料は文言の表示のみに利用するため、取得に失敗しても処理は継続する
     */
    result.fold(
      l => log.error(l),
      (r) => {
        if (r.isSome()) {
          this.serviceFeePercent = r.value.percent
        }
      }
    )
  }

  async init(): Promise<void> {
    const resultOfGuard = await this.guardBeforeInitialize()
    if (resultOfGuard.isLeft()) {
      log.warn(`guard before initialize failed, finally redirect to`, resultOfGuard.value)

      return
    }

    await Promise.all([
      this.initPurchaseMenu(),
      this.initCart(),
      this.initUser(),
      this.initContact(),
      this.initCreditcard(),
      this.initAppSetting(),
      this.initServiceFee(),
    ])

    await this.initNoveltyCampaign()

    // TODO: Comment on why and how these methods depend on the above, or refactor to take explicit arguments.
    await Promise.all([
      this.initDelivery(),
      this.initDeliveryDate(),
      this.loadCreditcardScript(),
      this.initCoupon(),
      this.initAvailablePaymentList(),
      this.initMailMagazine(this.cartItems),
    ])
    await this.initPayment()

    const path = this.guardBeforePurchaseEstimate()

    if (path) {
      log.warn('redirect because not satisfied guardBeforePurchaseEstimate', path)
      this.$router.push(path)

      return
    }

    await this.initPurchaseEstimate()
    await this.initApplicablePoint()

    // Presupposes that changing payment type always go through this order page initialization.
    // Only when payment type is 'atone', init atone script.
    // This process is done in async way so as not to delay the page rendering.
    // The status of atone script loading should be managed elsewhere.
    if (this.paymentType === 'atone') {
      this.loadAtoneScript()
    }

    // Presupposes that changing payment type always go through this order page initialization.
    // Only when payment type is 'paidy', init paidy script.
    // This process is done in async way so as not to delay the page rendering.
    // The status of paidy script loading should be managed elsewhere.
    if (this.paymentType === 'paidy') {
      this.loadAndConfigPaidyScript()
    }

    // もっと手前で呼んでもよさそう
    // initDeliveryとinitPaymentの実行完了直後に実行すれば、
    // presetの設定も自然と完了しそう？
    await this.initDeliveryConfigSpec()

    await this.initPointFeatureIsEnabled()
  }

  async initPurchaseMenu(): Promise<void> {
    const purchaseMenu = await this.purchaseService.getMenu()

    if (purchaseMenu.isLeft()) {
      log.error('error on initializing purchase menu', purchaseMenu.value)
      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }

    this.purchaseMenu = _.get(purchaseMenu.value, 'body.data')
  }

  async initCart(): Promise<void> {
    const payload: LoadWithScopePayload = {
      scope: this.scope,
    }

    return await this.$store.dispatch('cart/loadWithScope', payload)
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get', { force: true })
  }

  async initDelivery(): Promise<void> {
    if (this.delivery) {
      return
    }

    // TODO: Refactor to integrate
    await this.$store.dispatch('purchase/loadLatest')
    await this.$store.dispatch('contact/load')

    if (this.errorOnContactLoad) {
      log.error('error on loading contact', this.errorOnContactLoad)
      this.modalMessage = this.errorMessage
      this.showModal = true
      this.initializationStatus = Status.Failed

      return
    }

    // Check latest purchase for delivery
    const latestPurchase: SalesOrder | null = this.$store.getters['purchase/latestOfPurchase']

    const latestPurchaseContact: Contact | undefined = this.$store.getters['contact/get'](
      _.get(latestPurchase, 'delivery.contact_id')
    )

    if (latestPurchaseContact) {
      await this.$store.dispatch('orderConfirm/initializeDelivery', {
        id: latestPurchaseContact.id,
      })

      return
    }
    // Fallback: get display_level === 0 contact
    const firstContact: Contact = await this.$store.getters['contact/first']

    if (firstContact) {
      await this.$store.dispatch('orderConfirm/initializeDelivery', { id: firstContact.id })
    }
  }

  /**
   * ユーザーがこのページに遷移してきたときのデフォルトの配送設定を取得する。
   * ユーザーがこのページで配送方法・配送日・時間帯のいずれかを変更した場合、
   * SPA遷移している限りは最後にいずれかを変更したタイミングの上記3点設定を次回のデフォルト値とする。
   * ただし、変更後の配送方法が利用できない場合などは、配送方法をサーバーから取得する。
   * @see https://github.com/my-color/growthpalette-front/pull/7757#pullrequestreview-1753236658
   */
  async getDefaultDeliveryConfig(
    cartIds: string[],
    deliveryId: string,
    availableDeliveryMethods: DeliveryMethod[]
  ): Promise<DeliveryConfig> {

    const selectedDeliveryConfig: DeliveryConfig | null =
      this.$store.state.orderConfirm.selectedDeliveryConfig

    // SPA遷移でこのページに戻ってきた場合に、getDefaultDeliveryConfig でAPIが呼ばれるパターンを減らす
    // すでにユーザーが選択済みの配送方法が利用可能な場合は、
    // APIを呼び出さずオンメモリで保持されているユーザー選択結果を使用する
    // https://github.com/Everforth/growthpalette-front/pull/7757/files#r1417273859
    if (
      selectedDeliveryConfig &&
      availableDeliveryMethods.some(
        method => method.id === selectedDeliveryConfig.deliveryMethodDetail.id
      )
    ) {
      return selectedDeliveryConfig
    }

    const presetDeliveryMethod =
      await this.deliveryMethodRepository.getPreset(this.payment!.payment_type)

    const presetDeliveryMethodDetail = await this.deliveryMethodRepository.get(
      presetDeliveryMethod.id,
      {
        cartIds: cartIds.join(','),
        payment: this.payment!,
        deliveryId,
        deliveryMethod: presetDeliveryMethod.externalId,
      }
    )

    return {
      deliveryMethodDetail: presetDeliveryMethodDetail,
      deliveryDate: null,
      /**
       * 配送時間帯の初期値はエンジンまたは配送業者に依存するため、MCフロントで持つべき知識では無い。
       * しかし、現状（2021.03.08）ではMCフロント側で持たざるを得ない。
       * また現在のモデル設計の制約として、配送方法によっては配送時間帯初期値を知らないケース
       * がある（ネコポスの場合、または何らかの理由で配送日選択不可の場合）。
       * その場合はクライアント側で静的に持った初期値を設定する。
       * 詳細はこちら: https://github.com/my-color/front/pull/4959#pullrequestreview-606007153
       */
      deliveryTime: getDefaultDeliveryTime(),
      okihaiPlace: presetDeliveryMethodDetail.okihaiPlaces[0] || null,
    }
  }

  async initDeliveryConfigSpec() {
    // TODO: initDeliveryやinitDeliveryDateと統合して、「配送先の初期化」として一つまとまった処理にする
    try {
      const cartIds = _.flatMap<OrderItem, string>(this.orderList, (order: OrderItem) =>
        order.cartItems.map(cart => cart.id)
      )
      // NOTE: ストアから取得するため、先に this.initDelivery()が実行済みでなければならない
      const deliveryId = this.$store.state.orderConfirm.delivery.deliveryId
      // NOTE: ストアから取得するため、先に this.initPayment()が実行済みでなければならない
      const deliveryMethods = await this.deliveryMethodRepository.list(this.payment!.payment_type)
      const deliveryConfig =
        await this.getDefaultDeliveryConfig(cartIds, deliveryId, deliveryMethods)

      // selectedDeliveryConfig はユーザーが明示的に選択した配送方法なので
      // すでに設定されている = ユーザーが選択済みの場合は、初期化処理では変更しない
      if (!this.$store.state.orderConfirm.selectedDeliveryConfig) {
        this.$store.dispatch('orderConfirm/setSelectedDeliveryConfig', deliveryConfig)
      }

      this.deliveryConfigSpec = new OnlySingleDeliveryConfigBuilder(
        deliveryConfig.deliveryMethodDetail,
        deliveryConfig.deliveryDate,
        deliveryConfig.deliveryTime,
        deliveryMethods
      ).build(
        this.orderList,
        [
          {
            payment: this.payment!,
            cartIds,
            deliveryId,
          },
        ]
      )

      this.deliveryConfigSpec.configList.map(config => this.onChangeDeliveryConfig(config, false))
    } catch (e) {
      log.error('failed to initialize delivery configuration specification', e)
      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }
  }

  async initContact() {
    await this.$store.dispatch('contact/load')
  }

  /**
   * This methods requires that user and creditcards are all loaded in the store.
   */
  async initPayment(): Promise<void> {
    if (this.payment) {
      return
    }

    return (await this.paymentInitializationSpec.build()).fold(
      (error) => {
        log.error('error occured in initializing payment', error)

        this.modalMessage = this.errorMessage
        this.showModal = true
      },
      maybePayment => maybePayment.foldL(
        () => this.$router.push(this.context.path.editPayment),
        (paymentWithApiPayment) => {
          this.$store.dispatch('orderConfirm/setPayment', { payment: paymentWithApiPayment })
        }
      )
    )
  }
  get paymentInitializationSpec(): PaymentInitializationSpec {
    return setupPaymentInitializationSpec({
      purchaseService: new PurchaseService(),
      availablePaymentList: this.availablePaymentList,
      creditcardStore: {
        first: this.$store.getters['creditcard/first'],
        findById: id => this.$store.getters['creditcard/get'](id),
      },
      location,
    })
  }

  async initCreditcard() {
    await this.$store.dispatch('creditcard/load')
  }

  async initAvailablePaymentList() {
    const cartIdList = _.map(this.cartItems, cart => cart.id)
    const result = await this.paymentService.listAllowedPaymentsFor(cartIdList, {
      confirm_url: `${location.origin}/s/order?scope=${toQuery(this.scope)}`,
    })

    if (result.isLeft()) {
      log.error('failed to initialize available payment list', result.value)
      this.modalMessage = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      return
    }

    this.availablePaymentList = PaymentList.valueOf(result.value)
  }

  /**
   * NOTE: 配送日時選択不可あるいは未選択の状態で注文する場合は null と 0 という仕様
   * 詳細はこちら: https://github.com/my-color/front/pull/4959#pullrequestreview-606007153
   */
  async initDeliveryDate() {
    const deliveryDate = this.$store.state.orderConfirm.deliveryDate
    this.deliveryDate = _.get(deliveryDate, 'deliveryPlanDate', null)
    this.deliveryTimeSlot = _.get(deliveryDate, 'deliveryTimeSlot', '0')
  }

  async initCoupon() {
    const payload: LoadCouponPayload = {
      listCoupon: this.listCoupon,
    }

    await this.$store.dispatch('coupon/load', payload)
  }

  async initMailMagazine(cartItems: CartItem[]): Promise<any> {
    const brandNamesInCart = cartItems
      .map(cartItem => cartItem.brandEnglishName || '')
      .filter(name => !!name)

    const result =
      await this.mailMagazineSubscriptionInteractor.updateWithSpecifiedBrandSubscriptionAsFollowed(brandNamesInCart)
    result.fold(
      ((error) => {
        log.error({ error })
      }),
      ((interactor) => {
        this.mailMagazineSubscriptionInteractor = interactor
      })
    )
  }

  guardBeforePurchaseEstimate(): string | null {
    const pathOnBlankField = this.guardBlankField()

    if (pathOnBlankField) {
      return pathOnBlankField
    }

    const pathOnUnselectablePaymentType = this.guardOnUnselectablePaymentType(
      // TODO: 前段でpaymentTypeの存在チェックが行われているが、そのことが暗黙的になってしまっている。
      this.paymentType!
    )

    if (pathOnUnselectablePaymentType) {
      return pathOnUnselectablePaymentType
    }

    return null
  }

  guardBlankField(): string | null {
    // Payment type
    if (!this.paymentType) {
      return this.context.path.editPayment
    }

    // Delivery
    if (!this.delivery || !this.deliveryContact) {
      return this.context.path.editContact
    }

    return null
  }

  guardOnUnselectablePaymentType(paymentType: string): string | null {
    if (!this.isAvailablePayment(paymentType)) {
      return this.context.path.editPayment
    }

    return null
  }

  isAvailablePayment(paymentType: string): boolean {
    return this.availablePaymentList.isAvailablePayment(paymentType)
  }

  onChangeMagazine(_checkedIndex: number, _checkedItem: RawTag, updated: RawTag[]) {
    this.mailMagazineSubscriptionInteractor =
      this.mailMagazineSubscriptionInteractor.update(updated)
  }

  async persistMailMagazineSubscription(): Promise<void> {
    const registerMailMagazineResult = await this.mailMagazineSubscriptionInteractor.persistSubscription(
      this.user.id
    )

    if (registerMailMagazineResult.isLeft()) {
      log.error({ error: registerMailMagazineResult.value })
    }
  }

  async createProvisionalOrderIdForSingleOrderIfNotExist(): Promise<void> {
    if (this.provisionalOrderIdForSingleOrder) {
      return
    }

    const provisionalOrderIdResult = await this.purchaseService.createProvisionalOrderId()

    if (provisionalOrderIdResult.isLeft()) {
      return
    }

    this.provisionalOrderIdForSingleOrder = provisionalOrderIdResult.value
  }

  /**
   * 注文画面で表示されている全てのcheckoutを一括で行う
   */
  checkoutAll() {
    this.order(this.checkoutStore.allCheckoutKeys)
  }

  /**
   * 注文画面で表示されているcheckoutのうちひとつだけを実行する
   */
  checkoutIndividual(checkoutKey: CheckoutKey) {
    this.order([checkoutKey])
  }

  /**
   * @internal
   * privateにすると順番変えろって怒られたので、暫定的にinternalアノテーション
   * 最終的にはこの手続きはinteractionとかに移したいなあ
   */
  async order(checkoutKeys: CheckoutKey[]) {
    this.orderStatus = Status.Loading
    const validated = await this.validateOrder()

    if (!validated) {
      this.orderStatus = Status.Pending

      return
    }

    this.persistMailMagazineSubscription()

    const preparationState = new PurchasePreparationState(
      this.checkoutStore,
      this.payment!, // paymentはvalidateOrderに含まれている
      this.user,
      this.delivery!, // deliveryはvalidateOrderに含まれている
      this.deliveryDate,
      this.deliveryTimeSlot,
      this.appliedCouponId,
      this.couponDiscountPrice,
      this.appliedPoint,
      this.serviceFeePercent,
      this.scope
    )

    // FIXME: processAtone, processPaidyの責務の中で判定（支払額がないのでdefaultにデリゲートする）したほうが良さそう
    if (preparationState.paymentTypeIsUserSide && preparationState.isFullyDiscountedExceptForPayment) {
      await this.processPurchaseDefault(preparationState, checkoutKeys)
      this.orderStatus = Status.Pending

      return
    }

    switch (this.paymentType) {
      case 'atone':
        await this.processAtone(preparationState, checkoutKeys)
        break
      case 'paidy':
        await this.processPaidy(preparationState, checkoutKeys)
        break
      case 'creditcard3d':
        await this.processCreditCard3d(preparationState, checkoutKeys)
        break
      case 'creditcard':
        // 3Dセキュアでないクレジットカードに関する実装は削除できるようになるはず
        // ただし、全サービスの3Dセキュア完全対応後にまとめて削除するのでひとまず残しておく
        await this.processCreditcard(checkoutKeys)
        break
      default:
        await this.processPurchaseDefault(preparationState, checkoutKeys)
        break
    }

    this.orderStatus = Status.Pending
  }

  /**
   * @return Whether order content is valid
   */
  async validateOrder(): Promise<boolean> {
    // TODO: More validation
    const validated = await this.$validator.validateAll()

    if (!validated) {
      this.modalMessage = '入力内容が正しくありません'
      this.showModal = true

      return false
    }

    // Validate payment
    if (!await this.validatePaymentAndPrice()) {
      return false
    }

    // Validate delivery
    if (!this.delivery) {
      this.modalMessage = '配送先が選択されていません'
      this.showModal = true

      return false
    }

    // Validate cart ids
    if (_.isEmpty(this.cartItems)) {
      this.modalMessage = '現在カートに商品はありません。'
      this.showModal = true

      return false
    }

    // Novelty validation
    if (this.noveltyConstraint && !this.noveltyConstraint.isValid) {
      this.modalMessage = 'ノベルティが選択できる範囲を越えています。カート画面でお選び直しください。'
      this.showModal = true

      return false
    }

    return true
  }

  /**
   * @return Whether selected payment and price is valid for user
   */
  async validatePaymentAndPrice(): Promise<boolean> {
    // Validate payment
    if (!this.payment) {
      this.modalMessage = '支払い方法が選択されていません'
      this.showModal = true

      return false
    }

    // 注文確認画面に入った段階で設定されている支払方法が利用可能か検査されているので通常は通ることのないルート
    // バグ、データの改ざん、決済手続き中に設定が変更されたなどのイレギュラーなケースをガードする目的
    if (!this.isAvailablePayment(this.payment.payment_type)) {
      this.modalMessage = 'ご利用いただけないお支払い方法です。他のお支払い方法を選択してください。'
      this.showModal = true

      return false
    }

    // クレジットカードのみparametersが空になる
    if (this.payment.apiPayment && !this.payment.apiPayment.parameters.isEmpty) {
      return !(new OptionsValidator(
        this.payment.apiPayment.parameters,
        this.payment.selectedOptionList || SelectOptionList.empty()
      )).validate().hasSomeError
    }

    return true
  }

  async processAtone(purchasePreparationState: PurchasePreparationState, checkoutKeys: CheckoutKey[]): Promise<void> {
    this.clearAtoneErrorCodeAndMessage()

    const onFailed = (error: unknown, modalMessage?: string) => {
      // TODO: サーバーにエラーを送信したい
      log.error('processAtone failed', { error, modalMessage })
      this.modalMessage = modalMessage || this.errorMessage
      this.showModal = true
    }

    if (!Atone) {
      onFailed(new Error('atone script not found'), this.atoneScriptLoader.loadErrorMessage)

      return
    }

    try {
      const checkout = pipe(
        purchasePreparationState.validateCheckoutKeysMustBeSingle(checkoutKeys),
        chain(checkoutKey => purchasePreparationState.validateCheckoutExistence(checkoutKey))
      ).mapLeft((e) => { throw e }).value

      await this.createProvisionalOrderIdForSingleOrderIfNotExist()
      const orderId = this.provisionalOrderIdForSingleOrder
      if (!orderId) {
        throw new Error('not found provisional order id for single order in atone-process')
      }

      if (!this.deliveryContact) {
        throw new Error('not found delivery contact in atone-process')
      }

      /**
       * TODO: サービス手数料
       * @see https://github.com/Everforth/growthpalette-front/issues/6264
       */
      const atonePaymentItems = convertCartItemsForAtone({
        items: checkout.cartItems,
        shipping: this.isFreeShipping ? 0 : checkout.shippingFee,
        discountAmount: checkout.discountAmount,
      })
      const atonePayment = (await makeAtonePayment(
        orderId,
        this.user,
        this.deliveryContact,
        atonePaymentItems
      )).mapLeft((e) => { throw e }).value

      configAtone(
        this.user.id,
        {
          preToken: this.user.payment_auth_token || '',
          payment: atonePayment,
          authenticated: this.atoneAuthenticatedCallback,
          cancelled: this.atoneCancelledCallback,
          failed: this.atoneFailedCallback,
          succeeded: this.atoneSucceededCallback,
          error: this.atoneErrorCallback,
        }
      )

      this.atoneCheckoutProcessState.pushState({
        purchasePreparationState,
        checkout,
        orderId,
        paymentAuthToken: fromNullable(this.user.payment_auth_token),
      }).mapLeft((e) => { throw e })

      Atone.start()
    } catch (error) {
      onFailed(error)
    }
  }

  async withPurchaseTransaction(executePurchase: () => Promise<OrderPurchaseResult[]>): Promise<void> {
    await this.$store.dispatch('view/startLoading')

    try {
      const purchaseResult = await executePurchase()
      const afterExecuteResult = await this.afterExecutePurchase(purchaseResult)

      afterExecuteResult.fold(
        async () => { /* nothing */ },
        async () => {
          this.$router.push(this.context.path.orderComplete)
        }
      )
    } catch (error) {
      this.modalMessage = this.errorMessage
      this.showModal = true

      this.publishOrderPurchaseLogEvent(
        'failed-in-execute-purchase',
        'error',
        { errorMessage: error.message }
      )
    } finally {
      await this.$store.dispatch('view/stopLoading')
    }
  }

  /**
   * @return Flag to continue code flow
   */
  async afterExecutePurchase(purchaseResult: OrderPurchaseResult[]): Promise<AfterPurchaseProcessStatus> {
    if (purchaseResult.every(r => !r.success)) {
      if (this.paymentType === 'atone') {
        /**
         * reset order id as atone do not accept same order id twice.
         * see more: https://github.com/my-color/growthpalette-pm/issues/194
         */
        this.provisionalOrderIdForSingleOrder = null
      }
      if (this.hasTimeoutError(purchaseResult)) {
        this.modalConfig = {
          show: true,
          onClose: () => {
            this.$router.push(this.orderHistoryPath)
          },
          message: '引き続き購入手続きを処理中です。しばらくお待ち下さい。購入手続きの結果は購入履歴に反映されます（購入履歴へ移動します）',
          style: styleAsWarning,
        }

        return AfterPurchaseProcessStatus.failed()
      }

      /**
       * 旧モーダルを前提（modalMessage, showModalフラグを利用）した既存コード。
       */
      if (this.shouldRedirectToCart(purchaseResult)) {
        // TODO: use callback on closeModal
        this.shouldRedirect = true

      } else if (this.shouldReload(purchaseResult)) {
        this.modalConfig = {
          show: true,
          onClose: () => {
            // reload and detect item price changed in guardOnCart
            this.$router.go(0)
          },
          message: '商品の金額やその他手数料などが変更になったため決済を完了できませんでした。画面を再読み込みします。金額をお確かめの上、あらためてご注文ください。',
        }

        return AfterPurchaseProcessStatus.failed()
      }

      const modalMessage = this.createPurchaseErrorMessage(purchaseResult)
      this.modalMessage = modalMessage
      this.showModal = true

      this.publishOrderPurchaseLogEvent(
        'failed-in-execute-purchase',
        'error',
        {
          modalMessage,
          errors: purchaseResult.map(r => r.error ? r.error.message : null),
        }
      )

      return AfterPurchaseProcessStatus.failed()
    }

    if (this.redirectToPaymentIfNeed(purchaseResult)) {
      // リダイレクトが実行された場合にも、実際に遷移が完了するまでは後続の処理が実行されるので、
      // リダイレクトされたというステータスを返し処理を中断する
      return AfterPurchaseProcessStatus.redirected()
    }

    const [successOrders, failedOrders] = _.partition(purchaseResult, 'success')
    const historyResult = await this.orderHistoryApiService.list({ limit: successOrders.length })

    if (historyResult.isLeft()) {
      log.error('succeed purchase, but failed to get latest purchase history', historyResult.value)
      this.modalMessage = '購入に成功しましたが、購入履歴の取得に失敗しました'
      this.showModal = true

      return AfterPurchaseProcessStatus.failed()
    }

    const completedOrders: CommerceSalesOrder[] = _.get(historyResult.value, 'body.data', [])
                                                   .map(d => new CommerceSalesOrder(d))
    await this.setCompleteData(completedOrders, failedOrders as OrderPurchaseFail[])

    await this.$store.dispatch('cart/load', { force: true })

    return AfterPurchaseProcessStatus.completed()
  }

  createPurchaseErrorMessage(purchaseResults: OrderPurchaseResult[]): string {
    const topMessage = 'エラーが発生しました。<br/>決済手続きは完了しておりません。<br/>'
    const customerCenterMessage = '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
    const errorMessages = createPurchaseErrorMessage(purchaseResults, new CartItemList(this.displayCartItems))

    return [
      topMessage,
      ...errorMessages,
      ... this.shouldRedirectToCart(purchaseResults)
        ? ['<br/>カート画面に戻りますのでご確認ください。']
        : [],
      customerCenterMessage,
    ].join('<br />')
  }

  async setCompleteData(successOrders: CommerceSalesOrder[], failedOrders: OrderPurchaseFail[]) {
    const sortOrderResults = (results: OrderResult[]) => {
      return sortOrderResultsByOrderList(this.orderList, results)
    }
    const createOrderFromCartItems = (cartItems: CartItem[]) => {
      return this.orderService.createOrderFromCartItems(cartItems, this.deliveryDateForStandardOrder)
    }
    const builder = new CompleteDataBuilder(
      successOrders,
      failedOrders,
      this.cartItems,
      sortOrderResults,
      createOrderFromCartItems,
      {
        isFirstShareItem: this.isFirstShareItem,
        isFreeShipping: this.isFreeShipping,
        canScheduleDelivery: this.canScheduleDelivery,
      }
    )

    this.$store.dispatch('orderConfirm/setComplete', builder.build())
  }

  async loadAtoneScript() {
    const result = await this.atoneScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.atoneScriptLoader.loadErrorMessage
      this.showModal = true
    }
  }

  async atoneAuthenticatedCallback(authenticationToken: string, userNo: string): Promise<void> {
    return atoneAuthenticatedCallbackFactory(
      this.user.id,
      { authenticationToken, userNo },
      async (authToken: string) => {
        this.atoneCheckoutProcessState.partialUpdate({
          paymentAuthToken: some(authToken),
        }).mapLeft((e) => {
          log.error({ error: e.message })
          this.modalMessage = this.errorMessage
          this.showModal = true
        })
      },
      async () => {
        // エラー表示するだけでなくatoneの処理を強制的に中断したいがやり方が不明
        this.modalMessage = this.errorMessage
        this.showModal = true
      }
    )
  }

  atoneCancelledCallback(): Promise<void> {
    this.atoneCheckoutProcessState.reset()

    return atoneCancelledCallbackFactory(this.user.id)
  }

  atoneFailedCallback(response: any): Promise<void>  {
    this.atoneCheckoutProcessState.reset()

    return atoneFailedCallbackFactory(
      this.user.id,
      response,
      async () => {
        this.modalMessage = atoneErrorMessages(this.errorMessage, this.atoneErrors)
        this.showModal = true
      }
    )
  }

  async atoneSucceededCallback(response: any): Promise<void> {
    const actionOnSuccess = async () => {
      const { id } = response

      const onFailed = (error: Error, modalMessage: string) => {
        this.modalMessage = modalMessage
        this.showModal = true
        log.error({ error: error.message, modalMessage })
        this.publishOrderPurchaseLogEvent(
          'failed-in-atone-succeeded-callback',
          'error',
          { response, error: error.message, modalMessage }
        )
      }

      const atoneProcessingState = this.atoneCheckoutProcessState.popState()
      if (atoneProcessingState.isLeft()) {
        onFailed(atoneProcessingState.value, this.errorMessage)

        return
      }

      const { purchasePreparationState, checkout, orderId, paymentAuthToken } = atoneProcessingState.value
      if (paymentAuthToken.isNone()) {
        onFailed(new Error('paymentAuthToken does not exist in atoneCheckoutProcessState'), this.errorMessage)

        return
      }

      const purchaseExecutionProcess = await createPurchaseExecutionProcessFunctions.atone(
        this.orderService,
        purchasePreparationState,
        checkout,
        orderId,
        id,
        paymentAuthToken.value
      )
      if (purchaseExecutionProcess.isLeft()) {
        onFailed(new Error('failed to create purchase execution process atone'), purchaseExecutionProcess.value)

        return
      }

      await this.withPurchaseTransaction(purchaseExecutionProcess.value)
    }

    return atoneSucceededCallbackFactory(this.user.id, response, actionOnSuccess)
  }

  async atoneErrorCallback(name: string, message: string, errors: any[]) {
    atoneErrorCallbackFactory(
      this.user.id,
      { name, message, errors },
      async () => {
        this.atoneCheckoutProcessState.reset()
        this.storeAtoneErrorCodeAndMessage(errors)
        this.modalMessage = atoneErrorMessages(this.errorMessage, this.atoneErrors)
        this.showModal = true
      }
    )
  }

  async loadAndConfigPaidyScript() {
    const result = await this.paidyScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.paidyScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }

    this.paidyHandler = configPaidy(this.paidyCallback)
  }

  async paidyCallback(response: PaidyResponse): Promise<void> {
    return paidyCallbackFactory(response, this.paidyCallbackAction)
  }

  async paidyCallbackAction(response: PaidyResponse): Promise<void> {
    const { id, status } = response

    if (status === 'rejected') {
      log.error('rejected order by paidy', response)
      this.paidyCheckoutProcessState.reset()
      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }

    if (status !== 'authorized') {
      return
    }

    const popStateResult = this.paidyCheckoutProcessState.popState()
    if (popStateResult.isLeft()) {
      log.error({ error: popStateResult.value })
      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }
    const { purchasePreparationState, checkout, orderId } = popStateResult.value

    const purchaseExecutionProcess = await createPurchaseExecutionProcessFunctions.paidy(
      this.orderService,
      purchasePreparationState,
      checkout,
      orderId,
      id
    )
    if (purchaseExecutionProcess.isLeft()) {
      log.error(purchaseExecutionProcess.value)
      this.modalMessage = this.errorMessage
      this.showModal = true

      return
    }

    await this.withPurchaseTransaction(purchaseExecutionProcess.value)
  }

  async processPaidy(purchasePreparationState: PurchasePreparationState, checkoutKeys: CheckoutKey[]): Promise<void> {
    const onFailed = (error: unknown, modalMessage?: string) => {
      // TODO: サーバーにエラーを送信したい
      log.error('processPaidy failed', { error, modalMessage })
      this.modalMessage = modalMessage || this.errorMessage
      this.showModal = true
    }

    if (!Paidy) {
      onFailed(new Error('have not loaded paidy script yet, or failed'), this.paidyScriptLoader.loadErrorMessage)

      return
    }

    try {
      const checkout = pipe(
        purchasePreparationState.validateCheckoutKeysMustBeSingle(checkoutKeys),
        chain(checkoutKey => purchasePreparationState.validateCheckoutExistence(checkoutKey))
      ).mapLeft((e) => { throw e }).value

      await this.createProvisionalOrderIdForSingleOrderIfNotExist()
      const orderId = this.provisionalOrderIdForSingleOrder
      if (!orderId) {
        throw new Error('not found provisional order id for single order in paidy-process')
      }

      const items = convertCartItemsForPaidy(
        checkout.cartItems,
        checkout.discountAmount,
        {
          serviceFee: checkout.serviceFee,
        }
      )

      const payload = makePaidyPayload(
        orderId,
        this.user,
        this.deliveryContact!,
        items,
        this.isFreeShipping ? 0 : checkout.shippingFee
      )

      this.paidyCheckoutProcessState.pushState({
        purchasePreparationState,
        checkout,
        orderId,
      }).mapLeft((e) => { throw e })

      this.paidyHandler.launch(payload)
    } catch (error) {
      onFailed(error)
    }
  }

  async loadCreditcardScript() {
    await this.cardPaymentProvider.loadScript()
      .catch(() => {
        this.modalMessage = this.errorMessage
        this.showModal = true
      })
  }

  /**
   * @deprecated https://github.com/Everforth/growthpalette-front/issues/8279
   */
  async processCreditcard(_checkoutKeys: CheckoutKey[]): Promise<void> {
    log.error(`should not be reached.`)
    this.modalMessage = this.errorMessage
    this.showModal = true
  }

  async processCreditCard3d(
    preparationState: PurchasePreparationState,
    checkoutKeys: CheckoutKey[]
  ): Promise<void> {
    const createProcessResult = await createPurchaseExecutionProcessFunctions.creditCard(
      this.cardPaymentProvider,
      this.orderService,
      preparationState,
      checkoutKeys
    )
    await createProcessResult.fold<Promise<void>>(
      async (message: string) => {
        this.modalMessage = message
        this.showModal = true
      },
      async (process) => {
        this.withPurchaseTransaction(process)
      }
    )
  }

  async processPurchaseDefault(
    preparationState: PurchasePreparationState,
    checkoutKeys: CheckoutKey[]
  ): Promise<void> {
    const createProcessResult = await createPurchaseExecutionProcessFunctions.default(
      this.orderService,
      preparationState,
      checkoutKeys
    )
    await createProcessResult.fold<Promise<void>>(
      async (message: string) => {
        this.modalMessage = message
        this.showModal = true
      },
      async (process) => {
        this.withPurchaseTransaction(process)
      }
    )
  }

  /**
   * クーポンIDそのものというよりは、選択状態を表すためにnullも許容している。
   * 現状はnullをリーダブルにするために意味のある変数名として明示化しているに留めているが、
   * 将来的には選択状態を加味したクーポンIDを、独自型として定義してもよい。
   * そのためにはこのOrder.vueでselectedCouponIdを利用している箇所を変更する必要があるため、
   * いったんこのコメント追記で留めている。
   */
  get selectedCouponId(): string | null {
    return this.selectedCoupon ? this.selectedCoupon.id : null
  }

  get appliedCouponId(): string | null {
    return this.appliedCoupon ? this.appliedCoupon.id : null
  }

  onCouponApply(value: ApiCoupon) {
    /**
     * クーポンの選択状態を前提としてポイント適用可能額が決まるので、クーポンの選択状態が変更されたら適用ポイントも初期化しておく。
     */
    if (this.appliedPoint > 0) {
      this.initAppliedPoint()
    }

    this.$store.dispatch('orderConfirm/selectCoupon', {
      selected: value,
    })
  }

  onCouponUnapply() {
    this.$store.dispatch('orderConfirm/selectCoupon', {
      selected: null,
    })
  }

  onInputCouponCode(code: string) {
    this.$store.dispatch('coupon/inputCouponCode', code)
  }

  /**
   * 初期化前に各種データの状態をチェックし、不完全ならリダイレクト.
   *
   * @return リダイレクトが発生した時はLeft,リダイレクトが発生しなかった時はRight
   */
  async guardBeforeInitialize(): Promise<Either<Location, null>> {
    try {
      const baseParam = {
        scope: this.scope,
        context: this.context,
      }
      const redirectList: Array<Location | void> = await Promise.all([
        guardOnCart({
          ...baseParam,
          redirectLocation: () => ({
            path: this.cartPath,
          }),
          filter: isSinglePurchasable,
        }),
        guardOnUser({ ...baseParam, to: this.$route }),
        guardOnDelivery(baseParam),
      ])

      for (const redirect of redirectList) {
        if (redirect) {
          await store.dispatch('view/stopLoading')
          log.warn(`redirect to ${redirect}`)
          this.$router.push(redirect)

          return left(redirect)
        }
      }

      log.info(`all guard passed`)

      return right(null)
    } catch (err) {
      log.error('error on guard before initialize', err)
      this.modalMessage = this.errorMessage
      this.showModal = true

      throw err
    }
  }

  beforeRouteLeave(_to, _from, next) {
    this.setReplacedForSale(false)
    next()
  }

  shouldReload(purchaseResults: OrderPurchaseResult[]): boolean {
    return hasErrorOnCauseType(purchaseResults, 'ItemPriceChangedError') ||
      hasErrorOnCauseType(purchaseResults, 'InvalidServiceFeeError')
  }

  shouldRedirectToCart(purchaseResults: OrderPurchaseResult[]): boolean {

    return hasErrorOnCauseType(purchaseResults, 'NoItemsError') ||
           hasErrorOnCauseType(purchaseResults, 'NotInStoreError') ||
           hasErrorOnCauseType(purchaseResults, 'StockIsEmptyError') ||
           hasErrorOnCauseType(purchaseResults, 'UnitCountExceededError') ||
           hasErrorOnCauseType(purchaseResults, 'RootFkuNotPublicError') ||
           hasErrorOnCauseType(purchaseResults, 'NoveltyItemIncludedInCartError') ||
           hasErrorOnCauseType(purchaseResults, 'NoveltyConstraintError') ||
           hasErrorOnCauseType(purchaseResults, 'PurchaseDomainValidationError')
  }

  hasTimeoutError(results: OrderPurchaseResult[]): boolean {
    return timeoutErrorExistsInPurchaseResult(results)
  }

  closeModal() {
    this.showModal = false
    // TODO: use callback
    if (this.shouldRedirect) {
      this.$router.push(this.cartPath)
    }
  }

  private redirectToPaymentIfNeed(results: OrderPurchaseResult[]): boolean {
    // 注文完了後に呼ばれるので決済種別は必ずあることを期待する
    if (!this.paymentType) {
      return false
    }

    return createRedirectHtmlRenderer(
      this.paymentType,
      results.map(r => convertFromOrderPurchaseResult(r))
    ).render()
  }

  private publishOrderPurchaseLogEvent(
    event: string,
    level: 'error' | 'info',
    payload: any
  ): void {
    const userId = this.user.id
    EventBusForThirdParty.getInstance().publish('publish-developer-reports', [{
      userId,
      level,
      timestamp: new Date(),
      message: {
        userId,
        event,
        payload,
      },
      reportSource: 'orderPurchase',
    }])
  }
}

/**
 * 各種の割引（バンドル、クーポン、ポイントなど）には適用順序があり、先行する割引の情報が未取得の状態では正しい計算が行われない。
 * cf. 適用順序について: @link https://my-color.esa.io/posts/600
 * すでにserverでは正しい値でのバリデーションを行っているものの、見積に関しては未だclient側で計算しているものもある。
 * 見積APIを呼び出すとき、その見積結果でserver側から返される先行する種類の割引額を取得しないまま、後行する割引額をclientで計算してしまったものを見積APIに渡すと、
 * 見積APIで何らかの不整合が起こる可能性がある。@link https://github.com/my-color/front/issues/6749
 * そのため、後行する割引額を除いたパラメータで見積APIを呼び、その結果得られる先行割引額を使って後行する割引額を計算して、あらためて見積APIを呼びたい。
 * このI/Fは、そうした、割引額に関するパラメータを、割引の適用順序にそって可変化するための型を定義している。
 *
 * TODO: server側に、見積のためにユーザが希望する各種の値（カート商品IDやクーポンIDなど）を一挙に渡して、server側で適切な適用順序で整合的に割引結果を一挙に返すようにしたい。
 * そうすればclientとserverを往復して、割引の種類ごとに逐次的に見積APIを呼ぶ必要もなくなるし、割引の適用順序という知識をclientで抱え込む必要もない。
 * そのような改修が行われれば、この型およびこの型による見積API呼び出しの制御は、解消すべきものであり、それまでのワークアラウンドという位置づけである。
 *
 * booleanの意味: 各割引種類に対して、trueの場合はその割引種類のパラメータは見積APIに送信され、falseの場合は送信されない。
 */
type EnableDiscountParamForEstimate =
  {
    bundle: true
    coupon: true
    point: true
  } |
  {
    bundle: true
    coupon: true
    point: false
  } |
  {
    bundle: true
    coupon: false
    point: false
  }

const allDiscountsEnabledForEstimate: EnableDiscountParamForEstimate = {
  bundle: true,
  coupon: true,
  point: true,
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
